// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".str-chat-channel-list.messaging {\n  position: initial;\n}\n\n.str-chat.messaging {\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
